// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { LinkedSystem } from '../misc/LinkedSystem';
import TerceraLinkControlTemplate from '@front/templates/TerceraLinkControlTemplate.html';
import { ContainerControl } from './ContainerControl';
import { TerceraLinkControlConstants } from '../UtilsClasses/TerceraLinkControlConstants';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraLinkControl extends ContainerControl {
    constructor() {
        super();
        this._menuitems = [];
        this.completed = false;
    }
    getType() {
        return ControlsTypes.TerceraLinkControl;
    }
    oninit() {
        super.oninit();
        this.on('linkClick', () => {
            if (!this.get('linkByAccount')) {
                // https://tp.traderevolution.com/entity/83015
                this._menuitems.forEach((mi) => (mi.selected = mi.tag.value === this.get('selectedLinkValue')));
                const rect = this.el.getBoundingClientRect();
                showContextMenu({
                    x: rect.left,
                    y: rect.top + rect.height,
                    items: this._menuitems,
                    functions: {
                        closeCallback: () => {
                            void this.set({ isMenuOpened: false });
                        }
                    }
                });
                void this.set({ isMenuOpened: true });
            }
        });
        this.observe('selectedLinkValue', (newVal) => {
            this.setDataByValue(newVal);
        });
        this.observe('linkByAccount', (newVal) => {
            void this.set({ btnClass: newVal ? 'js-link-color-none-acc' : 'js-link-color-none' });
        });
    }
    oncomplete() {
        super.oncomplete();
        this.initContextMenu();
        this.completed = true;
    }
    setDataByValue(value) {
        const menuitems = this._menuitems;
        if (isNullOrUndefined(menuitems) || (menuitems === null || menuitems === void 0 ? void 0 : menuitems.length) === 0)
            return;
        const linkByAccount = this.get('linkByAccount');
        const skipLinkingCircle = this.get('skipLinkingCircle');
        for (const newData of menuitems) {
            if (skipLinkingCircle) {
                break;
            }
            if (newData.tag.value === value) {
                if (linkByAccount) {
                    void this.set({
                        btnClass: 'js-link-color-active',
                        btnName: 'accLink',
                        selectedLinkValue: newData.tag.value
                    });
                }
                else {
                    void this.set({
                        btnClass: newData.tag.style,
                        btnName: value === TerceraLinkControlConstants.STATE_NONE ? 'link' : 'circle',
                        selectedLinkValue: newData.tag.value
                    });
                }
                break;
            }
        }
        if (this.completed) {
            LinkedSystem.updateDictState(linkByAccount);
        }
    }
    initContextMenu() {
        const linkByAccount = this.get('linkByAccount');
        const clickItemEvent = (curItem) => {
            const tag = curItem.tag;
            void this.set({
                btnClass: tag.style,
                selectedLinkValue: tag.value
            });
        };
        if (linkByAccount) {
            this._menuitems = this.createAccLinkItems(clickItemEvent);
        }
        else {
            this._menuitems = this.createLinkItems(clickItemEvent);
        }
        this.setDataByValue(this.get('selectedLinkValue'));
    }
    createLinkItems(clickItemEvent) {
        const items = [];
        for (const curData of TerceraLinkControlConstants.LinkDataArray) {
            items.push({
                type: NewContextMenuItemType.Default,
                text: curData.textKey,
                svgImage: curData.value === TerceraLinkControlConstants.STATE_NONE ? 'link' : 'circle',
                iconStyle: curData.style,
                tag: { value: curData.value, style: curData.style },
                event: clickItemEvent
            });
        }
        return items;
    }
    createAccLinkItems(clickItemEvent) {
        const items = [];
        items.push({
            type: NewContextMenuItemType.Default,
            tag: { value: TerceraLinkControlConstants.STATE_NONE, style: 'js-link-color-none-acc' },
            event: clickItemEvent
        });
        items.push({
            type: NewContextMenuItemType.Default,
            tag: { value: TerceraLinkControlConstants.STATE_ALL, style: 'js-link-color-active' },
            event: clickItemEvent
        });
        return items;
    }
}
ContainerControl.extendWith(TerceraLinkControl, {
    template: TerceraLinkControlTemplate,
    data: function () {
        return {
            btnClass: '',
            selectedLinkValue: TerceraLinkControlConstants.STATE_NONE,
            linkByAccount: false,
            skipLinkingCircle: false,
            isMenuOpened: false
        };
    },
    menuitems: null
});
window.TerceraLinkControl = TerceraLinkControl;
